import * as actionTypes from "./propertyActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';

const { REACT_APP_API_URL } = process.env;

export const getProperty = (params) => {
  const config = {
    // public consumer endpoint, no auth header needed
  };

  return (dispatch) => {
    dispatch(getPropertyInit());

    // ✅ Normalize query parameters correctly
    const apiParams = {
      search: params.search,
      checkIn: params.checkIn || null,
      checkOut: params.checkOut || null,
      guest: params.guest || null,
      listingTypeId: params.listingTypeId || null,
      bedrooms: params.bedrooms || null,
      cityId: params.cityId || null,
      stateId: params.stateId || null,
      tag: params.tag || null,
      brand: params.brand || null,
    };

    // ✅ Remove undefined/null to avoid polluting query string
    Object.keys(apiParams).forEach(key => {
      if (!apiParams[key] || apiParams[key] === "undefined" || apiParams[key] === "") {
        delete apiParams[key];
      }
    });

    apiTimeout(
      axios.get(`${REACT_APP_API_URL}/property/consumer`, {
        params: apiParams,
        ...config,
      })
    )
      .then((response) => {
        const raw = response.data?.data;
        const list = Array.isArray(raw) ? raw : (raw?.rows && Array.isArray(raw.rows) ? raw.rows : []);
        dispatch(getPropertySuccess(list));
      })
      .catch(function (error) {
        dispatch(getPropertyFailure());
        checkError(error);
      });
  };
};




export const getPropertyInit = () => ({
    type: actionTypes.GET_PROPERTY
});

export const getPropertyFailure = () => ({
    type: actionTypes.GET_PROPERTY_FAILURE
});

export const getPropertySuccess = data => ({
    type: actionTypes.GET_PROPERTY_SUCCESS,
    payload: { data }
});

export const getPropertyByTag = (params) => {
    return (dispatch) => {
    dispatch(getPropertyByTagInit());
    return apiTimeout(axios.get(`${REACT_APP_API_URL}/property/by-tag`, {params}))
    .then((response) => {
        dispatch(getPropertyByTagSuccess(response.data.data));
        return response.data.data;
    })
    .catch(function (error) {
        dispatch(getPropertyByTagFailure());
        checkError(error);
        throw error;
    })
    };
};

/** Public list filtered by brand (slug or Brand id) — GET /property/by-brand */
export const getPropertyByBrand = (params) => {
  const { brand, limit, orderBy, orderType, search } = params || {};
  const brandParams = {
    brand,
    limit,
    orderBy,
    orderType,
    search,
  };
  Object.keys(brandParams).forEach((key) => {
    if (brandParams[key] === undefined || brandParams[key] === null || brandParams[key] === '') {
      delete brandParams[key];
    }
  });

  return (dispatch) => {
    dispatch(getPropertyByTagInit());
    return apiTimeout(axios.get(`${REACT_APP_API_URL}/property/by-brand`, { params: brandParams }))
      .then((response) => {
        dispatch(getPropertyByTagSuccess(response.data.data));
        return response.data.data;
      })
      .catch(function (error) {
        dispatch(getPropertyByTagFailure());
        if (error?.response?.status !== 404) {
          checkError(error);
        }
        return [];
      });
  };
};

export const getPropertyByTagInit = () => ({
    type: actionTypes.GET_PROPERTY_BY_TAG
});

export const getPropertyByTagFailure = () => ({
    type: actionTypes.GET_PROPERTY_BY_TAG_FAILURE
});

export const getPropertyByTagSuccess = data => ({
    type: actionTypes.GET_PROPERTY_BY_TAG_SUCCESS,
    payload: { data }
});


export const getPropertyById = (id, dateParams = {}) => {
    return (dispatch) => {
    dispatch(getPropertyByIdInit());
    const params = {};
    if (dateParams.checkIn) params.checkIn = dateParams.checkIn;
    if (dateParams.checkOut) params.checkOut = dateParams.checkOut;
    if (dateParams.checkin) params.checkIn = dateParams.checkin;
    if (dateParams.checkout) params.checkOut = dateParams.checkout;
    apiTimeout(axios.get(`${REACT_APP_API_URL}/property/${id}`, { params }))
    .then((response) => {
        // Check if property exists and has status=1
        if (!response.data.data || !response.data.data.property) {
            dispatch(getPropertyByIdFailure('Property not found'));
        } else {
        dispatch(getPropertyByIdSuccess(response.data.data));
        }
    })
    .catch(function (error) {
        const errorMessage = error.response?.status === 404 
            ? 'Property not found' 
            : error.response?.data?.message || 'Failed to load property';
        dispatch(getPropertyByIdFailure(errorMessage));
        // Only show error toast for non-404 errors
        if (error.response?.status !== 404) {
        checkError(error);
        }
    })
    };
};

export const getPropertyByIdInit = () => ({
    type: actionTypes.GET_PROPERTY_BY_ID
});

export const getPropertyByIdFailure = (error = null) => ({
    type: actionTypes.GET_PROPERTY_BY_ID_FAILURE,
    payload: error
});

export const getPropertyByIdSuccess = data => ({
    type: actionTypes.GET_PROPERTY_BY_ID_SUCCESS,
    payload: { data }
});

